import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/NotFound.css";

const NotFound = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-text">Oeps! De stroom is uitgevallen...</p>
        <p className="notfound-subtext">
          De pagina die je zoekt bestaat niet of is verplaatst.
        </p>
        <Link to="/" className="notfound-button">
          Terug naar Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
